<main class="container">
  <section
    [ngStyle]="{
      position: 'fixed',
      top: '5em',
      right: '10px',
      width: '98%',
      'z-index': '999'
    }"
  >
    <app-relogin-alert></app-relogin-alert>
    <app-alert-toast-notification></app-alert-toast-notification>
  </section>
  <app-loading></app-loading>
  <router-outlet></router-outlet>
</main>
